module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "moduleWrapper"
    }
  }, [(_vm.moduleType == 'CRUD') ? [(_vm.moduleActive == 'list') ? _c('module-list', {
    attrs: {
      "fields": _vm.fields(),
      "formIdentifier": _vm.formIdentifier(),
      "parentId": _vm.parentId,
      "parentColumnName": _vm.parentColumnName(),
      "title": _vm.title,
      "filter": _vm.moduleFilter,
      "showCreateButton": _vm.createView,
      "showEditIcon": _vm.editView,
      "showShowIcon": _vm.showView,
      "businessRulesBeforeCrudViewList": _vm.form.businessRulesBeforeCrudViewListId
    },
    on: {
      "changeModuleActive": _vm.changeModuleActive,
      "actionLinkSelected": _vm.actionLinkSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleActive == 'form') ? _c('module-form', {
    attrs: {
      "rows": _vm.rows(),
      "fields": _vm.fields(),
      "formIdentifier": _vm.formIdentifier(),
      "id": _vm.moduleActiveDataId,
      "parentId": _vm.parentId,
      "parentColumnName": _vm.parentColumnName(),
      "title": _vm.title,
      "businessRulesBeforeCrudViewCreate": _vm.form.businessRulesBeforeCrudViewCreateId,
      "businessRulesBeforeCrudViewEdit": _vm.form.businessRulesBeforeCrudViewEditId
    },
    on: {
      "changeModuleActive": _vm.changeModuleActive,
      "actionLinkSelected": _vm.actionLinkSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleActive == 'show') ? _c('module-show', {
    attrs: {
      "rows": _vm.rows(),
      "fields": _vm.fields(),
      "formIdentifier": _vm.formIdentifier(),
      "id": _vm.moduleActiveDataId,
      "parentId": _vm.parentId,
      "parentColumnName": _vm.parentColumnName(),
      "title": _vm.title,
      "showEditButton": _vm.editView,
      "showDeleteButton": _vm.deleteButton,
      "showCreateButton": _vm.createView,
      "businessRulesBeforeCrudViewShow": _vm.form.businessRulesBeforeCrudViewShowId
    },
    on: {
      "changeModuleActive": _vm.changeModuleActive,
      "actionLinkSelected": _vm.actionLinkSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.moduleActive == 'show') ? [(_vm.moduleChild.length) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('el-tabs', _vm._l((_vm._moduleChild), function(child) {
    return _c('el-tab-pane', {
      attrs: {
        "label": _vm.childTitle(child)
      }
    }, [_c('sgs-module-wrapper', {
      attrs: {
        "businessAreaId": _vm.formIdentifier().businessAreaId,
        "systemId": _vm.formIdentifier().systemId,
        "systemVersion": _vm.formIdentifier().systemVersion,
        "formId": child.id,
        "parentId": _vm.moduleActiveDataId
      }
    })], 1)
  }), 1)], 1)]) : _vm._e()] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'CUSTOM') ? [_c('module-custom', {
    attrs: {
      "title": _vm.title,
      "formIdentifier": _vm.formIdentifier(),
      "customTemplate": _vm.customTemplate,
      "parentId": _vm.parentId
    },
    on: {
      "actionLinkSelected": _vm.actionLinkSelected
    }
  })] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'DASHBOARD') ? [_c('module-dashboard', {
    attrs: {
      "rows": _vm.rows(),
      "fields": _vm.fields(),
      "formIdentifier": _vm.formIdentifier(),
      "parentId": _vm.parentId,
      "title": _vm.title,
      "businessRulesBeforeOtherView": _vm.form.businessRulesBeforeOtherViewId
    },
    on: {
      "actionLinkSelected": _vm.actionLinkSelected
    }
  })] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'REPORT') ? [_c('module-report', {
    attrs: {
      "rows": _vm.rows(),
      "fields": _vm.fields(),
      "formIdentifier": _vm.formIdentifier(),
      "parentId": _vm.parentId,
      "title": _vm.title,
      "businessRulesBeforeOtherView": _vm.form.businessRulesBeforeOtherViewId
    },
    on: {
      "actionLinkSelected": _vm.actionLinkSelected
    }
  })] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'FREE') ? [_c('module-free', {
    attrs: {
      "rows": _vm.rows(),
      "fields": _vm.fields(),
      "formIdentifier": _vm.formIdentifier(),
      "parentId": _vm.parentId,
      "title": _vm.title,
      "businessRulesBeforeOtherView": _vm.form.businessRulesBeforeOtherViewId
    },
    on: {
      "actionLinkSelected": _vm.actionLinkSelected
    }
  })] : _vm._e(), _vm._v(" "), (_vm.showDialogWithForm) ? _c('el-dialog', {
    attrs: {
      "visible": _vm.showDialogWithForm,
      "size": "large",
      "id": "modal"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialogWithForm = $event
      }
    }
  }, [_c('module-template', [_c('sgs-module-wrapper', {
    attrs: {
      "businessAreaId": _vm.formIdentifier().businessAreaId,
      "systemId": _vm.formIdentifier().systemId,
      "systemVersion": _vm.formIdentifier().systemVersion,
      "formId": _vm.formIdModal,
      "parentId": _vm.parentIdModal
    }
  })], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e1a27232!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/module/components/ModuleWrapper.vue
// module id = 966
// module chunks = 2